// parseJurisdiction infers a court system ('federal' | 'state' | 'all') and, when
// possible, a state from a proof graph's stored jurisdiction id / court name. It
// powers the court-rules deadline engine's jurisdiction preselection.
export const parseJurisdiction = (graph: { jurisdiction_id?: string; court_name?: string } | null | undefined): { court_system: string; state?: never; } | { court_system: string; state: string | undefined; } => {
  if (!graph) return { court_system: 'all' };

  const jId = (graph.jurisdiction_id ?? '');
  const courtName = (graph.court_name ?? '');

  let court_system = 'all';
  if (jId.startsWith('federal') || courtName.toLowerCase().includes('u.s.') || courtName.toLowerCase().includes('united states') || courtName.toLowerCase().includes('district court') || jId.startsWith('d_') || jId.includes('_d_')) {
    court_system = 'federal';
  } else if (jId || courtName) {
    court_system = 'state';
  }

  let state: string | undefined = undefined;
  if (jId) {
    const parts = jId.split('-');
    if (parts[0] === 'federal' && parts[1]) {
      state = parts[1].toUpperCase();
    } else {
      const firstPart = jId.split('_')[0];
      if (firstPart?.length === 2) {
        state = firstPart.toUpperCase();
      }
    }
  }

  if (!state && courtName) {
    const states = [
      "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
      "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
      "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan",
      "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire",
      "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio",
      "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota",
      "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia",
      "Wisconsin", "Wyoming", "District Of Columbia"
    ];
    const matched = states.find(s => courtName.toLowerCase().includes(s.toLowerCase()));
    if (matched) {
      state = matched;
    }
  }

  return { court_system, state };
};
